import { Component, EventEmitter, HostListener, OnInit } from '@angular/core';
import { environment } from './../environments/environment';
import API_URL from './shared/utils/api-url-homolog';
import { Subscription } from 'rxjs';
import { NavigationStart, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

export let browserRefresh = false;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'alerta-web';

  subscription: Subscription;

  constructor(private router: Router, private snackBar: MatSnackBar) {
    this.subscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        browserRefresh = !this.router.navigated;
      }
    });
  }

  ngOnInit(): void {}

  @HostListener('window:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.shiftKey && event.key === 'F5') {
      this.clearLocalStorage();
    }
  }

  clearLocalStorage() {
    localStorage.clear();
    this.snackBar.open('Cache limpo com sucesso!', 'Fechar', {
      duration: 5000,
      panelClass: ['snackbar-success'],
    });
  }
}

export const OnAppModuleInit = new EventEmitter<string>();
